let $headerContainer;
let $mainNav;

function init() {

    $headerContainer = $(".header-container");
    $mainNav = $headerContainer.find("nav");

    setHeaderColor();
    setHeaderScroll();

    $(window).on('load resize scroll', setHeaderScroll);

    $("#sandcHeader .navbar-toggler").on("click", handleNavbarTogglerClick);

    $(".nav-item.mega-nav > a.nav-link").on("click", function () {
        $(".mega-menu").addClass("show-mm");
    });
    $(".back-l1").on("click", function () {
        $(".mega-menu").removeClass("show-mm");
    });
    $(".mega-menu .nav-pills .nav-link").on("click", function () {
        $(".v-pills-tabContent.tab-content").addClass("show-tab");
    });
    $(".back-l2").on("click", function () {
        $(".v-pills-tabContent.tab-content").removeClass("show-tab");
    });
    $(".navbar-toggler").on("click", function () {
        $(".mega-menu").removeClass("show-mm");
        $(".v-pills-tabContent.tab-content").removeClass("show-tab");
    });

}

function handleNavbarTogglerClick() {
    if (isNavbarTogglerVisible()) {
        $("body").toggleClass("no-scroll");
    }
}

function isNavbarTogglerVisible() {
    return $('#sandcHeader .navbar-toggler').is(":visible");
}

function setHeaderScroll() {
    if ($(this).scrollTop() > 1) {
        $('#sandcHeader').addClass('scroll');
    } else {
        $('#sandcHeader').removeClass('scroll');
    }
}

function setHeaderColor() {
    if ($("#page-content").hasClass("header-alt")) {
        $mainNav.addClass("alt");
        $headerContainer.find(".navbar-nav").addClass("alt");
    }
}

export default {
    init
}